import React from 'react';
import TIcontent from '../components/TIcontent';
import Footer from '../components/footer';


const TIpage = () => {
  return (
    <div className="TI">
       
          <TIcontent />
          <Footer />
    </div>
  );
}

export default TIpage;